module.exports = __webpack_public_path__ + "static/george-75799c41adc369d525e8f36ab9647251.png";